import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GetByIdProfileUseCaseInterface } from 'domain/usecases';

interface IProfileState {
  profileList: GetByIdProfileUseCaseInterface.Result;
}

interface IPayloadProfileList
  extends PayloadAction<GetByIdProfileUseCaseInterface.Result> {}

const initialState: IProfileState = {
  profileList: null,
};

export const ProfileSlice = createSlice({
  name: 'profileList',
  initialState,
  reducers: {
    loadProfile: (state, action: IPayloadProfileList) => {
      state.profileList = action.payload;
    },
  },
});

export const { loadProfile } = ProfileSlice.actions;

export default ProfileSlice.reducer;
